import { render, staticRenderFns } from "./DataListStaffs_encours.vue?vue&type=template&id=66d2bb2c&"
import script from "./DataListStaffs_encours.vue?vue&type=script&lang=js&"
export * from "./DataListStaffs_encours.vue?vue&type=script&lang=js&"
import style0 from "./DataListStaffs_encours.vue?vue&type=style&index=0&id=66d2bb2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports